export default function BnbIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48" id="binance">
      <path
        fill="#F3BA2F"
        d="M14.6782 20.1697L23.9997 10.8486 33.3262 20.1746 38.7501 14.7507 23.9997 0 9.25431 14.7458 14.6782 20.1697zM10.8479 23.9988L5.42408 18.575.00000129498 23.9991 5.42381 29.4229 10.8479 23.9988zM14.6782 27.8296L23.9997 37.1507 33.3258 27.825 38.7527 33.2459 38.7501 33.2489 23.9997 47.9993 9.25394 33.2539 9.24635 33.2463 14.6782 27.8296zM42.5759 29.4254L48 24.0013 42.5762 18.5775 37.1521 24.0016 42.5759 29.4254z"
      ></path>
      <path
        fill="#F3BA2F"
        d="M29.5014 23.9968H29.5036L23.9997 18.4929L19.9323 22.5604H19.9319L19.4648 23.0278L18.5008 23.9919L18.4932 23.9995L18.5008 24.0074L23.9997 29.5064L29.5036 24.0025L29.5063 23.9995L29.5014 23.9968Z"
      ></path>
    </svg>
  );
}
